import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';

export const Sestavy = {
	name: NAME,
	menu,
	router,
};
